const viewTypes = [
    'cards',
    'list'
];
const imageGallery = {
    state: {
        gallery: 'myimages',
        sortOrder: 0,
        sortDirection: 0,
        view: 'cards'
    },
    getters: {
        getGallery(state) {
            return state.gallery;
        },
        getSortOrder(state) {
            return state.sortOrder;
        },
        getSortDirection(state) {
            return state.sortDirection;
        },
        getView(state) {
            return state.view;
        }
    },
    mutations: {
        setGallery(state, gallery) {
            state.gallery = gallery;
        },
        setSortOrder(state, sortOrder) {
            state.sortOrder = sortOrder;
        },
        setSortDirection(state, sortDirection) {
            state.sortDirection = sortDirection;
        },
        setView(state, view) {
            state.view = viewTypes.includes(view) ? view : viewTypes[0];
        }
    },
    actions: {
        setCurrentGallery({ commit }, gallery) {
            commit('setGallery', gallery);
        },
        setCurrentSortOrder({ commit }, sortOrder) {
            commit('setSortOrder', sortOrder);
        },
        setCurrentSortDirection({ commit }, sortDirection) {
            commit('setSortDirection', sortDirection);
        },
        setCurrentView({ commit }, view) {
            commit('setView', view);
        }
    }
};

export default imageGallery;